/**
 * パスワード変更フォーム（ダイアログ用）
 *
 * 通常のパスワード変更用。サイドメニューからダイアログで表示する。
 * 共通の PasswordFormFields を DialogBody/DialogFooter でラップする。
 */

import { type FC } from "react";
import { DialogBody } from "../../../components/atoms";
import { PasswordFormFields } from "./PasswordFormFields";

interface PasswordChangeFormProps {
  onSuccess: () => void;
}

export const PasswordChangeForm: FC<PasswordChangeFormProps> = ({ onSuccess }) => (
  <DialogBody>
    <PasswordFormFields
      submitLabel="パスワードを変更する"
      onSuccess={onSuccess}
    />
  </DialogBody>
);
